
import { useNavigate } from "react-router-dom";

interface Team {
  _id: string;
  team_name: string;
  team_number: number;
  total_points: number;
  is_winner: boolean;
}

interface GameHistoryBoxProps {
  gameId: string;
  title: string;
  time: string;
  teams: Team[];
}

const GameHistoryBox = ({ gameId, title, time, teams }: GameHistoryBoxProps) => {
  const navigate = useNavigate();
  // Sort teams by points (highest first)
  const sortedTeams = [...teams].sort((a, b) => b.total_points - a.total_points);
  const handleNavigate = () => {
    navigate(`/result/${gameId}`);
  };
  return (
    <div onClick={handleNavigate} className="w-full h-full flex flex-col bg-primary-ivory 2xl:rounded-[1.04vw] rounded-2xl 2xl:p-[0.91vw] p-3.5 text-center 2xl:border-[0.13vw] border-2 border-black-300 cursor-pointer">
      <h3 className="font-garamond 2xl:text-[2vw]/snug md:text-3xl/tight text-2xl/tight font-semibold text-black-900 2xl:mb-[0.1vw] mb-1">
        {title}
      </h3>
      <span className="text-black-900 2xl:text-[1vw]/snug text-lg/snug font-bold block text-center">
        {time}
      </span>
      <div className="2xl:mt-[1vw] mt-3 grid 2xl:gap-y-[0.5vw] gap-y-1 flex-1 content-start">
        {sortedTeams.map((team, index) =>
          team.is_winner ? (
            <div className="perspective-[250px]">
              <button
                key={team._id}
                className="flex justify-between items-center min-w-full 2xl:py-[0.3vw] xl:py-2.5 py-2 2xl:px-[1.17vw] xl:px-4 px-3  2xl:text-[0.5vw]/tight text-base/tight bg-primary 2xl:border-[0.13vw] border-2 border-black-300 shadow-[0px_2px_0px_0px_#110706] text-black-300 2xl:text-[1.30vw] font-bold 2xl:rounded-[0.33vw] rounded-[5px] rotate-x-10 text-left"
              >
                <span>{team.team_name}</span> <span>{team.total_points}</span>
              </button>
            </div>
          ) : (
            <div className="perspective-[250px]">
              <button
                key={team._id}
                className={`cursor-pointer flex justify-between items-center min-w-full 2xl:py-[0.3vw] py-2.5 2xl:px-[1.17vw] xl:px-4 px-3 2xl:text-[0.5vw]/tight text-base/tight bg-primary-orange 2xl:border-[0.13vw] border-2 border-black-300 shadow-[0px_2px_0px_0px_#110706] text-white 2xl:text-[1.30vw] font-bold 2xl:rounded-[0.33vw] rounded-[5px] rotate-x-10 text-left ${index > 0 ? "2xl:mt-[0.41vw] md:mt-2 mt-1" : ""}`}
              >
                <span>{team.team_name}</span> <span>{team.total_points}</span>
              </button>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default GameHistoryBox;
